import { default as React, useContext } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { InitialComputationDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import { keys } from "ts-transformer-keys";
import classNames from "classnames";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: InitialComputationDto[];
    hubs: MultiSelectItem[];
}

const List = ({ t, data, hubs, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const keysInDto = keys<InitialComputationDto>();
    const dtoHubs = hubs;

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn fixedHeader" style={{ top: top + "px", left: left + "px" }}></th>
                    <th colSpan={10} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:infoCnec")}</th>
                    <th colSpan={9} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:infoContingency")}</th>
                    <th colSpan={20 + (dtoHubs.length)} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:detailRam")}</th>
                </tr>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>

                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:tso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:cneName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:cneEic")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:direction")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:hubFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:hubTo")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:substationFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:substationTo")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:elementType")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fmaxType")}</th>

                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_cnec:tso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:contingencyName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:branchName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:branchEic")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:hubFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:hubTo")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:substationFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:substationTo")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:elementType")}</th>


                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_cnec:presolved")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:ram")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:imax")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:u")}</th>
                    <th className="fixedHeader" style={{ top: top + "px", whiteSpace: "nowrap" }}>{t("page_cnec:fmax")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:frm")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:frefinit")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fnrao")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fref")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fcore")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fall")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:fuaf")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:amr")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:ltaMargin")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:cva")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:iva")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:ftotalLtn")}</th>

                    {dtoHubs.map((hub) => <th key={hub.id} className="fixedHeader" style={{ top: top + "px" }}>{t("page_cnec:ptdf") + t("common_hubs:" + hub.id)}</th>)}
                </tr>
            </thead>
            <tbody>
                {
                    data && data.map((d) => <Row key={d.id} dto={d} hubs={dtoHubs} left={left} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("page_cnec")(List);

export default translated;